import { CompanyProperties } from '../../company/types/company.type';
import { DeviceProperties } from '../../device/types/device.type';

export enum EAssetType {
  FMS = 'fms',
  EMS = 'ems',
  BUNKER = 'bunker',
  SINGLE_ENGINE = 'single_engine',
}

export enum EAssetCategory {
  SHIP = 'ship',
}

export enum EAssetShipType {
  TANKER = 'tanker',
  CARGO = 'cargo',
  PASSENGER = 'passenger',
}

export type AssetMigrationStage = 'staged' | 'cutoff';

export type AssetMetadata = Record<string, unknown> & {
  showEventEngine?: number;
  showOperationMode?: number;
  ramusMigration?: Record<string, unknown> & {
    stage?: AssetMigrationStage;
    sourceAssetId?: string;
  };
};

export type AssetProperties = {
  assetId: string;
  name: string;
  isRamus2?: boolean;
  status: string;
  assetType: EAssetType;
  assetCategory: EAssetCategory;
  picName?: string;
  picPhoneNumber?: string;
  gsmNumber?: string;
  imeiNumber?: string;
  satelliteId?: string;
  satelliteDeviceId?: string;
  satelliteOperator?: string;
  installationAt?: Date;
  companyId: string;
  createdByUserId: string;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  imoNumber?: number;
  mmsiNumber?: number;
  callSign?: string;
  shipType?: string;
  dimensionLength?: number;
  dimensionBeam?: number;
  dimensionDraught?: number;
  antennaPosition?: string;
  company?: CompanyProperties;
  imageLink?: string;
  aliasId?: string;
  devices?: DeviceProperties[];
  userCreator?: {
    name?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
  };
  metadata?: AssetMetadata;
  timezone?: number;
  telemetryMqttAllowedClient?: {
    assetId: string;
    clientId: string;
    description?: string | null;
  } | null;
};

export const initialAsset: AssetProperties = {
  assetId: '',
  name: '',
  status: '',
  createdByUserId: '',
  companyId: '',
  assetType: EAssetType.BUNKER,
  assetCategory: EAssetCategory.SHIP,
};

export interface ICreateAsset {
  name: string;
  status: string;
  assetType: EAssetType;
  assetCategory: EAssetCategory;
  picName?: string;
  picPhoneNumber?: string;
  gsmNumber?: string;
  imeiNumber?: string;
  satelliteId?: string;
  satelliteDeviceId?: string;
  satelliteOperator?: string;
  installationAt?: Date;
  imoNumber?: number;
  mmsiNumber?: number;
  callSign?: string;
  shipType?: string;
  dimensionLength?: number;
  dimensionBeam?: number;
  dimensionDraught?: number;
  antennaPosition?: string;
  companyId: string;
  aliasId?: string | null;
  addAsMqttClient?: boolean;
  mqttClientId?: string;
  mqttClientDescription?: string;
  image: File[];
  showEventEngine?: boolean;
  showOperationMode?: boolean;
}
